import LocalStoragekeys from "Constants/LocalStoragekeys";
import { PROFILE_STATE } from "Constants/ReduxStates";
import ReducerTypes from "Redux/Types/ReducerTypes";
import { getCookie } from "./../Actions/CommonActions";

const INITIAL_STATE = {
  accessToken: getCookie(LocalStoragekeys.Access_Token),
  profile: {},
};

function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ReducerTypes.CLEAR_TOKEN_RALTED_DATA:
      return INITIAL_STATE;
    case ReducerTypes.PROFILE_DETAIL:
      return { ...state, profile: action.payload };
    case ReducerTypes.ACCESS_TOKEN:
      return { ...state, accessToken: action.payload };
    case ReducerTypes.CLEAR_TOKEN:
      return {
        ...state,
        accessToken: null,
        profile: PROFILE_STATE,
        provinceSelection: null,
      };

    default:
      return state;
  }
}
export default authReducer;
